export default __webpack_public_path__ + "static/modal02_01-3177952a8686b062c2fab3f845474764.jpg";